<div class="col-xs-12">
  <div class="panel panel-default">
    <div class="panel-heading">
      Filtros
    </div>
    <div class="panel-body">
      <form ng-submit="buscarClick()">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <label for="nomeCompleto">Nome/Login</label>
            <input class="form-control" ng-model="filters.nomeCompleto" type="text" id="nomeCompleto" name="nomeCompleto">
          </div>

          <div class="col-xs-12 col-md-6">
            <label>Função</label>
            <ui-select ng-model="filters.funcao" theme="bootstrap">
              <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao | humanize}}</ui-select-match>
              <ui-select-choices repeat="funcao in funcoes | filter: $select.search">
                <span class="form-group" ng-bind-html="funcao.descricao | humanize | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12 col-md-6">
            <label>Utiliza Mobile</label>
            <ui-select ng-model="filters.mobile" theme="bootstrap">
              <ui-select-match allow-clear="true" placeholder="">{{$select.selected.descricao | humanize}}</ui-select-match>
              <ui-select-choices repeat="value in mobileStatus | filter: $select.search">
                <span class="form-group" ng-bind-html="value.descricao | humanize | highlight: $select.search"></span>
              </ui-select-choices>
            </ui-select>
          </div>

          <div class="col-xs-12 col-md-6">
            <label>&nbsp;</label><br>
            <button class="btn btn-success" ng-click="buscarClick()">
              Buscar <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>